module.exports = __webpack_public_path__ + "static/media/Pin_Drop_OrangeDS2.2482f48d.webp";